import {useEffect, useCallback} from 'react'
import {useSearchParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import {ROLE_FRANCHISE_MANAGER} from 'shared/constant/lookup/role'
import useRoleCookie from 'shared/model/useRoleCookie'

const useGetFranchiseManagerTicketList = () => {
	const [searchParams] = useSearchParams()
	const page = searchParams.get('page')
	const [userRole] = useRoleCookie()

	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const refetch = useCallback(() => {
		if (userRole === ROLE_FRANCHISE_MANAGER) {
			let url = `/admin/store_ticket/store_summary?page=${page || 1}`
			fetchRequest('GET', url)
		}
	}, [page])

	useEffect(() => {
		refetch()
	}, [refetch])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'page')
					setAlert('페이지 번호 입력 양식을 확인해 주세요.')
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading, refetch]
}

export default useGetFranchiseManagerTicketList
